import { Task, ScheduledTask } from "./types"; // Adjust the import path as needed

const TASK_SCHEDULE_BASE_URL = process.env
  .REACT_APP_TASK_SCHEDULE_BASE_URL as string;

export const schedule = async (
  task: Task,
  workerCount: number,
): Promise<ScheduledTask> => {
  const url = `${TASK_SCHEDULE_BASE_URL}/schedule`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      subtasks: task.subtasks,
      workerCount: workerCount,
    }),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  const { subtasks, totalDuration } = await response.json();
  const scheduledTask: ScheduledTask = {
    taskID: task.taskID,
    taskTitle: task.taskTitle,
    subtasks: subtasks,
    totalDuration: totalDuration,
  };
  return scheduledTask;
};
